<div class="card rounded-top-left-0">
    <div class="card-header">
        <h1>Asociar Nota de Salida a una Venta</h1>
    </div>
    <div class="card-body">
        <div class="mb-3 d-flex gap-3 align-items-end flex-wrap">
      <div class="text-muted">
        <i class="fa fa-circle-info"></i>
        Selecciona una orden a la izquierda y marca las ventas a asociar a la derecha. Una venta solo puede estar asociada a una sola orden.
      </div>
    </div>
    <div class="row">
        <svg id="svg-container" #svgContainer></svg>

      <!-- Tabla de Notas de Ingreso -->
      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar Nota de Ingreso</label>
          <input type="text" [(ngModel)]="filterExitNotes" (input)="debouncedFilterNotes()"
                 class="form-control" placeholder="Número de orden / proveedor" />
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-notes">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <!-- <th>Total</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let note of exitNotes"
                  [attr.data-id]="note.id"
                  (click)="selectExitNote(note.id)"
                  [class.selected]="note.id === selectedExitNoteId">
                <td>
                  <i [ngClass]="note.id === selectedExitNoteId ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                </td>
                <td>{{ note.number }}</td>
                <td>{{ note.clientName }}</td>
                <td>{{ note.date | date:'yyyy-MM-dd HH:mm' }}</td>
                <!-- <td>{{ order.total | number:'1.2-2' }}</td> -->
              </tr>

              <tr *ngIf="exitNotes.length === 0">
                <td colspan="5" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron órdenes.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="orders-pag"
          [sizes]="[5,10,20]"
          (changed)="selectedExitNoteId = null; refreshExitNotesPagination()"
          [elements]="paginationExitNotes">
        </app-simple-pagination>
      </div>
      <div class="col">
        <div class="form-group">
          <label class="form-label">Buscar Venta</label>
          <input type="text" [(ngModel)]="filterSales" (input)="debouncedFilterSales()"
                 class="form-control" placeholder="Serie-Numero de venta / proveedor" />
          <div class="mb-3 row">
            <div class="col-md-6">
              <label class="form-label">Fecha inicio</label>
              <input type="date" class="form-control" [(ngModel)]="startDate" (change)="reloadSales()" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Fecha fin</label>
              <input type="date" class="form-control" [(ngModel)]="endDate" (change)="reloadSales()" />
            </div>
          </div>
        </div>

        <div class="table-responsive mt-3">
          <table class="table table-bordered" id="table-sales">
            <thead>
              <tr class="tr-middle">
                <th></th>
                <th>Número</th>
                <th>Proveedor</th>
                <th>Fecha</th>
                <th>Total</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of sales"
                  [attr.data-id]="p.id"
                  (click)="toggleSale(p)"
                  [class.selected]="selectedSaleId == p.id"
                  [class.disabled]="isSaleLocked(p)">
                <td>
                    <i [ngClass]="selectedSaleId == p.id ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                  <!-- <i *ngIf="!isSaleLocked(p)"
                     [ngClass]="currentRelatedSaleIds.includes(p.id) ? 'fa-solid fa-circle' : 'fa-regular fa-circle'"></i>
                  <i *ngIf="isSaleLocked(p)" class="fa-solid fa-lock"></i> -->
                </td>
                <td>{{ p.number }}</td>
                <td>{{ p.providerName }}</td>
                <td>{{ p.date | date:'yyyy-MM-dd' }}</td>
                <td>{{ p.total | number:'1.2-2' }}</td>
                <td class="text-center">
                  <span *ngIf="!(currentRelatedId && currentRelatedId === p.id)" class="badge bg-secondary">Sin asociación</span>
                  <span *ngIf="currentRelatedId && currentRelatedId === p.id" class="badge bg-success">Asociada a esta orden</span>
                  <!-- <span *ngIf="p.associatedOrderId && p.associatedOrderId !== selectedOrderId" class="badge bg-warning text-dark">Asociada a otra orden</span> -->
                </td>
              </tr>

              <tr *ngIf="sales.length === 0">
                <td colspan="6" class="text-muted">
                  <i class="fa fa-circle-info"></i> No se encontraron ventas.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <app-simple-pagination
          id="sales-pag"
          [sizes]="[5,10,20]"
          (changed)="refreshSalesPagination()"
          [elements]="paginationSales">
        </app-simple-pagination>
      </div>
    </div>

    <div class="row mt-4">
        <div class="col" *ngIf="selectedExitNoteId">
            <h5>Detalles de la Nota de Entrada: </h5>
            <div class="row" *ngIf="currentExitNote && currentExitNote.details.length > 0">
                <div class="col">
                    <div class="table-responsive table-bordered">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>Código</th>
                                <th class="text-right bg-warning-subtle">Cantidad</th>
                                <th class="td-center bg-info-subtle">Unidad/Item</th>
                                <th>Description</th>
                                <th class="text-right">Cantidad Recibida</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let detail of currentExitNote.details">
                                <td>{{ detail.productData.code }}</td>
                                <td class="text-right bg-warning-subtle">{{ detail.quantity }}</td>
                                <td class="td-center bg-info-subtle">{{ detail.item }}</td>
                                <td>{{ detail.productData.name }}</td>
                                <td class="text-right">{{ detail.quantityReceived }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="col"  *ngIf="selectedSaleId">
            <h5>Detalles de la(s) venta(s)</h5>
            <table class="table table-bordered" id="table-orders">
                <thead>
                    <tr class="tr-middle">
                    <th>Código</th>
                    <th>Nombre</th>
                    <th class="">Cantidad</th>
                    <th class="">Precio U</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let sales of currentSales">
                    <td>{{ sales.productData.code }}</td>
                    <td>{{ sales.productData.name }}</td>
                    <td>{{ sales.quantity }}</td>
                    <td>{{ sales.price.toFixed(2) }}</td>
                    </tr>

                    <tr *ngIf="currentSales.length === 0">
                    <td colspan="5" class="text-muted">
                        <i class="fa fa-circle-info"></i> No se encontraron órdenes.
                    </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- Botón Guardar -->
    <div class="actions">
    <button class="btn btn-success"
            [disabled]="getDisabledSave() || buttonAssociate.loading"
            (click)="saveAssociation()">
        <i class="fa" [ngClass]="buttonAssociate.icon"></i>
        Guardar
        <!-- {{ buttonAssociate.text }} -->
    </button>
    </div>
    </div>
</div>